export const likeFunctions = {
  ARTICLE: 'ArticleLike',
  INTERNAL_ARTICLE: 'InternalArticleLike',
  POST: 'PostLike',
};
